import { render, staticRenderFns } from "./AddEmployeesToCourse.vue?vue&type=template&id=ac21a400"
import script from "./AddEmployeesToCourse.vue?vue&type=script&lang=js"
export * from "./AddEmployeesToCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports